import type { RankMovement } from "../lib/api";

type Props = {
  movement: RankMovement | null | undefined;
  delta: number | null | undefined;
};

export default function RankMovementBadge({ movement, delta }: Props) {
  if (movement === "up") {
    return (
      <span
        className="rank-movement rank-movement--up"
        title={delta != null ? `+${delta}` : undefined}
      >
        ▲{delta != null ? Math.abs(delta) : ""}
      </span>
    );
  }
  if (movement === "down") {
    return (
      <span
        className="rank-movement rank-movement--down"
        title={delta != null ? String(delta) : undefined}
      >
        ▼{delta != null ? Math.abs(delta) : ""}
      </span>
    );
  }
  if (movement === "same") {
    return <span className="rank-movement rank-movement--same">—</span>;
  }
  if (movement === "new") {
    return <span className="rank-movement rank-movement--new">●</span>;
  }
  return <span className="muted">—</span>;
}
